/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Confirm_Refresh_TitleInputs */

const en_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh Items?`)
};

const ar_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحديث المنتجات؟`)
};

const de_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikel aktualisieren?`)
};

const es_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Actualizar los artículos?`)
};

const fr_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser les articles ?`)
};

const it_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornare gli articoli?`)
};

const ja_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品を更新しますか？`)
};

const ko_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품을 새로고침할까요?`)
};

const pt_br_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar os itens?`)
};

const ru_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить товары?`)
};

const th_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีเฟรชสินค้าไหม?`)
};

const tr_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürünler yenilensin mi?`)
};

const zh_cn_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新商品？`)
};

const zh_tw_dialog_confirm_refresh_title = /** @type {(inputs: Dialog_Confirm_Refresh_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新商品？`)
};

/**
* | output |
* | --- |
* | "Refresh Items?" |
*
* @param {Dialog_Confirm_Refresh_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_confirm_refresh_title = /** @type {((inputs?: Dialog_Confirm_Refresh_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Confirm_Refresh_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_confirm_refresh_title(inputs)
	if (locale === "ar") return ar_dialog_confirm_refresh_title(inputs)
	if (locale === "de") return de_dialog_confirm_refresh_title(inputs)
	if (locale === "es") return es_dialog_confirm_refresh_title(inputs)
	if (locale === "fr") return fr_dialog_confirm_refresh_title(inputs)
	if (locale === "it") return it_dialog_confirm_refresh_title(inputs)
	if (locale === "ja") return ja_dialog_confirm_refresh_title(inputs)
	if (locale === "ko") return ko_dialog_confirm_refresh_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_confirm_refresh_title(inputs)
	if (locale === "ru") return ru_dialog_confirm_refresh_title(inputs)
	if (locale === "th") return th_dialog_confirm_refresh_title(inputs)
	if (locale === "tr") return tr_dialog_confirm_refresh_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_confirm_refresh_title(inputs)
	return zh_tw_dialog_confirm_refresh_title(inputs)
});